import { mapStrings } from "../../lib/frTypo";

/**
 * "Loulenn" reel — on-screen copy, FR only for now.
 *
 * Facts given by the team (nothing else is claimed): Loulenn just had its
 * first successful referral, 30 € for the referrer (le parrain) and 10 € for
 * the referee (le filleul). The amounts live in `LOULENN_REWARDS`; the
 * brand name and logo come from the live snapshot (`merchant/merchants`).
 * End line: B2C video (landing brands.hub.title); end sub: B2C cta.sub
 * (faq.a1 free, faq.a3 no followers, /vs cash), same as the Ticket reel.
 * B2C house style: tutoiement, no em dashes, no hype words.
 */
export const LOULENN_REWARDS = { referrer: 30, referee: 10 } as const;

export const LOULENN = mapStrings({
  /** One word per line on the cover; the last one gets the accent. */
  hook: "Premier parrainage réussi",
  /** {name}: the brand, as spelled in the directory. */
  forBrand: "pour {name}",
  referrer: "Pour le parrain",
  referee: "Pour le filleul",
  end: {
    line: "Des marques qui paient leurs ambassadeurs.",
    sub: "Gratuit. Sans abonnés. Du vrai cash.",
  },
});
